import { render, staticRenderFns } from "./Occasionwishlist.vue?vue&type=template&id=70edc0ba"
import script from "./Occasionwishlist.vue?vue&type=script&lang=js"
export * from "./Occasionwishlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports